import LoadingAction from "@common/redux/actions/LoadingAction";
import CustomerReviewAction from "@common/redux/actions/CustomerReviewAction";
import ReviewClient from "@common/api/ReviewClient";
import useCustomerReviewModal from "./customerInteractionAdmin/useCustomerReviewModal";
import { handleError } from "../helpers/error";
import useCustomerReviewsFilters from "./useCustomerReviewsFilters";
import { useSelector } from "react-redux";
import { fromDate, toDate } from "../helpers/datetime";

const useReviews = () => {
  const { selectedCustomer, setCustomerReviewModalState } =
    useCustomerReviewModal();

  const {
    id,
    dateRange,
    reviewStatusTypeIds,
    isEscalated,
    setState: setReviewFiltersState,
  } = useCustomerReviewsFilters();

  const setState = CustomerReviewAction.dispatch;

  const data = useSelector((state) => CustomerReviewAction.getStatePath(state));

  const payload = {
    id: id || null,
    customerId: selectedCustomer?.id,
    reviewStatusTypeIds,
    reviewDateFrom: fromDate(dateRange),
    reviewDateTo: toDate(dateRange),
    isEscalated,
  };

  const getReviewsMetadata = () => {
    ReviewClient.SearchMetadata().then((response) => {
      setReviewFiltersState({ ...response });
    });
  };

  const getCustomerReviews = () => {
    LoadingAction.set(true).then(() => {
      getReviewsMetadata();
      ReviewClient.Search(payload)
        .then((response) => {
          setCustomerReviewModalState({
            selectedCustomerReviews: response,
            selectedRecord: null,
          });
        })
        .catch(handleError)
        .finally(() => LoadingAction.set(false));
    });
  };

  const onCustomerReviewClick = (id) => {
    LoadingAction.set(true).then(() => {
      ReviewClient.UpdateMetadata(id)
        .then((response) => {
          setState({
            selectedReview: response,
            form: { ...response?.record },
          });
        })
        .catch(handleError)
        .finally(() => LoadingAction.set(false));
    });
  };

  return {
    ...data,
    id,
    fromDate,
    toDate,
    getCustomerReviews,
    onCustomerReviewClick,
  };
};

export default useReviews;
